(() => {
  const revealReadyImages = () => {
    document.querySelectorAll('.template--product .main-product__media img').forEach((image) => {
      const markReady = () => image.closest('.media')?.classList.add('is-media-ready');
      if (image.complete) markReady();
      else image.addEventListener('load', markReady, { once: true });
    });
  };

  const pauseMotionWhenRequested = () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      revealReadyImages();
      pauseMotionWhenRequested();
    }, { once: true });
  } else {
    revealReadyImages();
    pauseMotionWhenRequested();
  }
})();

